/**
 * return the height given mdRows
 */
export const computeHeightInRows = _ref => {
  let mdRows = _ref.mdRows;
  return mdRows ? parseInt(mdRows, 10) : 1;
};
export const computeHeightInPixels = format => "".concat(32 * computeHeightInRows(format), "px");